import { ReactNode } from 'react';
import { Popover as MuiPopover, PopoverProps } from '@mui/material';
import { IconButton, IIconButton } from '@components/iconButton';

interface IPopover extends PopoverProps {
  children: ReactNode;
  iconButtonProps?: IIconButton;
  doNotShowIconButton?: boolean;
}

export const Popover = (props: IPopover) => {
  const { children, iconButtonProps, doNotShowIconButton, open, ...other } = props;

  return (
    <>
      {/* not sure what this is used for but - adding undesired space to table */}
      {doNotShowIconButton ? null : (
        <IconButton
          id='popover-button'
          aria-controls={open ? 'custom-popover' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup='true'
          {...iconButtonProps}
        />
      )}
      <MuiPopover id='custom-popover' open={open} {...other}>
        {children}
      </MuiPopover>
    </>
  );
};
